import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const ArrowUp = (props) => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
    <g transform="translate(0 24) rotate(-90)">
      <path d="M16.01,11H4v2H16.01v3L20,12,16.01,8Z" />
    </g>
  </SvgIcon>
);
export default ArrowUp;



// WEBPACK FOOTER //
// ./src/common/icons/ArrowUp/index.tsx